import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	selector: 'sp-beta-pill',
	template: `Beta`,
	styles: [
		`
			:host {
				border-radius: 6px;
				border: 1px solid currentcolor;

				display: flex;
				padding: 4px 6px;
				justify-content: center;
				align-items: center;
				gap: 2px;

				text-align: center;
			}
		`,
	],
})
export class BetaPillComponent {}
